import { render, staticRenderFns } from "./Recoger.vue?vue&type=template&id=58f29d2c&"
import script from "./Recoger.vue?vue&type=script&lang=js&"
export * from "./Recoger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports